import { element } from 'protractor';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-independence-question',
  templateUrl: './independence-question.component.html',
  styleUrls: ['./independence-question.component.css']
})
export class IndependenceQuestionComponent implements OnInit {
  @Input() element : {index:number,question:String,id:number}
  @Output() agreeChanged = new EventEmitter<{agree : boolean,id:number}>()
  agree=false;

  constructor() { }

  ngOnInit(): void {
  }


  onAgreeClick(){
    console.log("in click");
    console.log("agree",this.agree)
    this.agree=!this.agree;
    this.agreeChanged.emit({agree:this.agree,id:this.element.id})
  }

}
